(function (){
    'use strict';
    angular.module('elogbooks.admin.scd-imports', []);
})();
